module.exports = __webpack_public_path__ + "../resources/img/module_icon.79c57934.svg";